export default defineNuxtRouteMiddleware(() => {
	const routeUrl = useRouteUrl()
	const companyStore = useCompanyStore()
	if (!companyStore.companyId) {
		return navigateTo(routeUrl.PanelDashboardUrl())
	}
})
